import React from 'react'

export const EMAIL_MANAGEMENT_TABLE_COLUMNS = [
  {
    field: 'email',
    align: 'left',
    width: 240,
  },
  {
    title: 'Fecha',
    field: 'dg_ts_insert',
    align: 'left',
    width: 150,
    type: 'date',
    exportType: 'date',
    customSort: (a, b) => new Date(a.dg_ts_insert) - new Date(b.dg_ts_insert),
  },
  {
    title: 'Motivo',
    field: 'motive',
    align: 'left',
    width: 350,
  },
  {
    title: 'Blacklist',
    field: 'blacklist_actions',
    align: 'center',
    width: 120,
    sorting: false,
    filtering: false,
  },
  {
    title: 'Whitelist',
    field: 'whitelist_actions',
    align: 'center',
    width: 120,
    sorting: false,
    filtering: false,
  },
]
